import * as _ from 'lodash';

export const TASK_VISIBILITY_COMPANY = '2';

const sameCompany = (item, companyId) =>
  _.toString(_.get(item, 'company_id')) === _.toString(companyId);

const updateGroupCount = (name, count) =>
  _.replace(name || '', /\(\d+\)\s*$/, `(${count})`);

const updateOptionCounts = (item, count) => {
  const companyName = updateGroupCount(item.company_name, count);

  return {
    name: _.includes(item.name, item.company_name)
      ? _.replace(item.name, item.company_name, companyName)
      : updateGroupCount(item.name, count),
    company_name: companyName,
  };
};

export const filterTaskPeopleOptionsByCompany = (
  options,
  companyId,
  visibility
) => {
  if (_.toString(visibility) !== TASK_VISIBILITY_COMPANY) {
    return options;
  }

  return _.filter(
    _.map(options, (item) => {
      if (_.get(item, 'type') && _.get(item, 'type') !== 'member') {
        const items = _.filter(_.get(item, 'items', []), (member) =>
          sameCompany(member, companyId)
        );

        if (_.isEmpty(items)) {
          return null;
        }

        return {
          ...item,
          items,
          ...updateOptionCounts(item, _.size(items)),
        };
      }

      return sameCompany(item, companyId) ? item : null;
    })
  );
};

export const filterTaskPeopleValueByCompany = (
  value,
  companyId,
  visibility
) => {
  if (_.toString(visibility) !== TASK_VISIBILITY_COMPANY) {
    return value;
  }

  return _.filter(value || [], (item) => sameCompany(item, companyId));
};
